/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {BodyTypography} from '../../typography/BodyTypography';
import {SavedPlacesProps} from './SearchView';

/**
 * @SearchPlaceItemLabelProps
 *
 * @prop item The SavedPlacesProp instance for this label.
 * @prop searchTerm The search terms of the searched place.
 * @prop isSaved When true, indicates that this is a saved place
 */
type SearchPlaceItemLabelProps = {
  item: SavedPlacesProps;
  searchTerm: string;
  isSaved?: boolean
};

// defines the styles for this component ...
export const useStyles = makeStyles(theme => ({
  highlight : {
    fontWeight : 'bold'
  }
}));

/**
 * @SearchPlaceItemLabel
 *
 * Provides the conditional labels which are dispalyed within a Places Search
 * Result and or Saved Places Item.
 */
export const SearchPlaceItemLabel = ({item, isSaved, searchTerm = ''}: SearchPlaceItemLabelProps) => {
  const classes     = useStyles();
  const address     = item?.text || '';
  const length      = searchTerm.length;
  const start       = address.toLowerCase().indexOf(searchTerm?.toLowerCase());
  const highlighted = address.substring(start, length);
  const normal      = address.substring(start + length);
  let children;
  if (!item.label) {
    if (!start) {
      children = (
        <>
          <span className={classes.highlight}>{highlighted}</span>
          <span>{normal}</span>
        </>
      );
    } else {
      children = address;
    }
  } else {
    children = <span className={isSaved ? classes.highlight : null}>{item.label}</span>;
  }
  return <BodyTypography>{children}</BodyTypography>;
};
export default SearchPlaceItemLabel;
